/* Ethetic Bundle Builder — theme asset. Aug 27: tiers 10/15/20 (badged EXTRA #% OFF), no free prints, 4+ expandable to 10 with BEST VALUE bar. Free US shipping over $100 (dynamic pill). Step 1 header: Build Your Bundle. Trust line under ATC (black): free US shipping over $100 + Made in USA. */
(function () {
  var FREE_SHIP_MIN_CENTS = 10000; /* $100 USD, US only */
  function normStr(s) { return String(s || '').toLowerCase().replace(/["\s]/g, ''); }
  function collsOf(p) { return Array.isArray(p.collections) ? p.collections : (p.collection ? [p.collection] : []); }
  var HIDDEN_COLLS = ['all', 'allposters', 'newarrivals', 'worldcup'];
  function visibleColl(t) { return t && HIDDEN_COLLS.indexOf(normStr(t)) === -1; }
  var DIM_RE = /(\d+(?:\.\d+)?)\s*[xX×]\s*(\d+(?:\.\d+)?)/;
  function dimArea(s) { var m = String(s || '').match(DIM_RE); return m ? parseFloat(m[1]) * parseFloat(m[2]) : null; }
  function dispSize(s) { return String(s || '').replace(/24\s*[xX×]\s*36/g, '24x32'); }
  var CM_MAP = { '12x16': '30x40cm', '18x24': '45x60cm', '24x32': '60x80cm' };
  var POPULAR_SIZE = '18x24';
  function sizeKey(s) {
    var m = String(s || '').match(DIM_RE);
    return m ? (parseInt(m[1], 10) + 'x' + parseInt(m[2], 10)) : '';
  }
  function dispSizeCm(s) {
    var d = dispSize(s);
    var cm = CM_MAP[sizeKey(d)];
    if (!cm) return d;
    return d + ' <span style="color:#8a8781;font-weight:400;font-size:12px">(' + cm + ')</span>';
  }
  function dispSizeCmText(s) {
    var d = dispSize(s);
    var cm = CM_MAP[sizeKey(d)];
    if (!cm) return d;
    return d + ' (' + cm + ')';
  }
  function popBadge(s) {
    return sizeKey(dispSize(s)) === POPULAR_SIZE ? ' <span style="background:#111;color:#fff;font-size:9px;font-weight:800;padding:2px 6px;border-radius:3px;letter-spacing:.04em;white-space:nowrap;vertical-align:middle">MOST POPULAR</span>' : '';
  }
  var SLIDER_COLLS = [
    { label: 'Motivation', keys: ['motivation'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Motivation_0afe2aac-81ca-48cc-95f0-28e9cbee4ae5.png?v=1787284229' },
    { label: 'Lifestyle', keys: ['lifestyle'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Lifestyle_5d0a602f-f80f-4bdc-92ee-fe7d6483e973.png?v=1787284230' },
    { label: 'Music', keys: ['music'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Music_81c5b547-25c5-4ffd-b18a-5b007f2b166f.jpg?v=1787284229' },
    { label: 'Bible Verse', keys: ['bibleverse', 'bible'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Bible_4a098840-d2d3-428e-a163-fe077c9809a5.png?v=1787284229' },
    { label: 'Formula 1', keys: ['formula1', 'f1'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/F1.png?v=1787284283' },
    { label: 'Dictionary', keys: ['dictionary'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Dictionary_a5bc6d54-b16e-4e59-b82d-39069738a2c.png?v=1787284229' },
    { label: 'Automotive', keys: ['automotive', 'auto'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Automotive_ecfbaf91-7269-4f28-aeeb-dcab7a479e69.jpg?v=1787284228' },
    { label: 'Sports', keys: ['sports', 'sport'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/Sports_2e74fb75-326b-41b4-b4cf-31d51b73572f.png?v=1787284229' },
    { label: 'City', keys: ['city', 'cities'], img: 'https://cdn.shopify.com/s/files/1/0719/3290/3735/files/City_63193522-e8fb-423e-ab18-1f3af26da1a1.jpg?v=1787284874' }
  ];
  var CUSTOM_FIELDS = [
    { match: 'album', fields: ['Album Name', 'Artist Name'] },
    { match: 'dictionary', fields: ['Word', 'Definition'] },
    { match: 'city', fields: ['City Name', 'Country Name'], img: true },
    { match: 'car', fields: ['Car Name'], img: true }
  ];
  var CUSTOM_FALLBACK = { fields: ['Personalization'] };
  function isCustom(p) { return p && /custom/i.test(p.title || ''); }
  function customEntryFor(p) {
    if (!isCustom(p)) return null;
    var t = normStr(p.title);
    for (var i = 0; i < CUSTOM_FIELDS.length; i++) {
      if (t.includes(CUSTOM_FIELDS[i].match)) return CUSTOM_FIELDS[i];
    }
    return CUSTOM_FALLBACK;
  }
  function customFieldsFor(p) { var e = customEntryFor(p); return e ? e.fields : null; }
  function customImgFor(p) { var e = customEntryFor(p); return !!(e && e.img); }
  function resolveValue(want, list) {
    if (!want || !Array.isArray(list)) return null;
    return list.find(v => v === want)
      || list.find(v => normStr(v).startsWith(normStr(want)))
      || list.find(v => normStr(v).includes(normStr(want)))
      || null;
  }
  function shiftKeys(obj, prefix, removedIdx) {
    var out = {};
    Object.keys(obj).forEach(function (k) {
      var parts = k.split(':');
      if (parts[0] !== prefix) { out[k] = obj[k]; return; }
      var i = +parts[1];
      if (i === removedIdx) return;
      out[prefix + ':' + (i > removedIdx ? i - 1 : i)] = obj[k];
    });
    return out;
  }
  function centerH(container, el) {
    if (!container || !el) return;
    container.scrollLeft = Math.max(0, el.offsetLeft - (container.clientWidth - el.offsetWidth) / 2);
  }
  function visibleOverlays() {
    var out = [];
    var els = document.body.querySelectorAll('div,aside,section,dialog,iframe');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var st = window.getComputedStyle(el);
      if (st.position !== 'fixed' && st.position !== 'absolute') continue;
      if (st.display === 'none' || st.visibility === 'hidden' || parseFloat(st.opacity || '1') < 0.05) continue;
      var r = el.getBoundingClientRect();
      if (r.width < 120 || r.height < window.innerHeight * 0.3) continue;
      if (r.right < 0 || r.left > window.innerWidth) continue;
      out.push(el);
    }
    return out;
  }
  function openCartDrawer(fallbackUrl) {
    var kc = window.kachingCartApi;
    if (kc && typeof kc.openCart === 'function') {
      try { if (typeof kc.refreshCart === 'function') kc.refreshCart(); } catch (e) {}
      try { kc.openCart(); return; } catch (e) {}
    }
    var before = visibleOverlays();
    try { if (window.Shopify && Shopify.actions && typeof Shopify.actions.openCart === 'function') { Shopify.actions.openCart(); } } catch (e) {}
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('shopify:cart:change', { bubbles: true }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    } catch (e) {}
    var candidates = ['a[href="/cart"]', 'a[href^="/cart?"]', '[data-cart-drawer-toggle]', '[data-drawer-toggle="cart"]', '.cart-icon', '#cart-icon-bubble', '[aria-controls*="cart" i]'];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) {
        try { el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); } catch (e) {}
        break;
      }
    }
    function newOverlayAppeared() {
      var now = visibleOverlays();
      for (var j = 0; j < now.length; j++) {
        if (before.indexOf(now[j]) === -1) return true;
      }
      return false;
    }
    var checks = 0;
    var timer = setInterval(function () {
      checks++;
      if (newOverlayAppeared()) { clearInterval(timer); return; }
      if (checks >= 6) { clearInterval(timer); window.location.href = fallbackUrl; }
    }, 250);
  }
  class EtheticBundleBuilder extends HTMLElement {
    connectedCallback() {
      try {
        const dataEl = this.querySelector('script[type="application/json"]');
        if (!dataEl) throw new Error('config script tag missing');
        this.cfg = JSON.parse(dataEl.textContent);
        if (!Array.isArray(this.cfg.sizes) || !this.cfg.sizes.length) throw new Error('no size option detected on this product');
        if (!Array.isArray(this.cfg.frames) || !this.cfg.frames.length) throw new Error('no frame option detected on this product');
        const seen = {};
        this.cfg.catalog = (this.cfg.catalog || []).filter(p => { if (!p || seen[p.id]) return false; seen[p.id] = 1; return true; });
        const unf = this.cfg.frames.filter(f => /unfram/i.test(f));
        const blk = this.cfg.frames.filter(f => !/unfram/i.test(f) && /black/i.test(f));
        const rest = this.cfg.frames.filter(f => !/unfram/i.test(f) && !/black/i.test(f));
        this.cfg.frames = unf.concat(blk, rest);
        this.sizeTiers = this.cfg.sizes.slice().sort(function (a, b) { return (dimArea(a) || 0) - (dimArea(b) || 0); });
        this._sizeCache = {};
        const defSize = resolveValue(this.cfg.defaultSize, this.cfg.sizes);
        const defFrame = resolveValue(this.cfg.defaultFrame, this.cfg.frames);
        const collList = [];
        const collImg = {};
        this.cfg.catalog.forEach(p => collsOf(p).forEach(t => {
          if (!visibleColl(t)) return;
          if (collList.indexOf(t) === -1) collList.push(t);
          if (!collImg[t] && p.image) collImg[t] = p.image;
        }));
        this.collList = collList;
        this.collImg = collImg;
        this.sliderColls = SLIDER_COLLS.map(e => {
          const t = collList.find(ct => e.keys.some(k => normStr(ct).includes(k)));
          return t ? { label: e.label, title: t, img: e.img || collImg[t] || null } : null;
        }).filter(Boolean);
        const defColl = collList.find(t => /best/i.test(t)) || collList[0] || null;
        this.state = {
          pack: this.cfg.packs[0],
          sizeValue: defSize || this.cfg.sizes[0],
          frameValue: defFrame || this.cfg.frames[0],
          paid: [], custom: {}, customFile: {}, sizeBy: {}, frameBy: {}, pickTarget: null, filter: defColl, busy: false, sizeOpenKey: null
        };
        if (this.cfg.currentProduct) this.state.paid = [this.cfg.currentProduct];
        this.setPack(this.state.pack);
      } catch (e) {
        console.error('[bundle-builder]', e);
        const root = this.querySelector('[data-bb-root]');
        if (root) root.innerHTML = '<div class="bb-error">Bundle builder failed to load: ' + (e && e.message ? e.message : 'unknown error') + '</div>';
      }
    }
    disconnectedCallback() { if (this._portal) { this._portal.remove(); this._portal = null; } }
    fmt(cents) { return '$' + (cents / 100).toFixed(2); }
    frameImg(f) {
      const fi = this.cfg.frameImages || {};
      const key = Object.keys(fi).find(k => normStr(f).includes(k));
      return key && fi[key] ? fi[key] : null;
    }
    sizesOf(product) {
      if (!product) return [];
      const cached = this._sizeCache[product.id];
      if (cached) return cached;
      const vals = [];
      (product.variants || []).forEach(v => (v.options || []).forEach(o => {
        if (dimArea(o) != null && vals.indexOf(o) === -1) vals.push(o);
      }));
      vals.sort(function (a, b) { return dimArea(a) - dimArea(b); });
      this._sizeCache[product.id] = vals;
      return vals;
    }
    sizeFor(product, want) {
      if (!product || !want) return want;
      const exact = (product.variants || []).some(v => (v.options || []).some(o => normStr(o) === normStr(want)));
      if (exact) return want;
      const own = this.sizesOf(product);
      if (!own.length) return want;
      let idx = this.sizeTiers.findIndex(t => normStr(t) === normStr(want));
      if (idx === -1) {
        const wa = dimArea(want);
        idx = 0;
        if (wa != null) {
          let best = Infinity;
          this.sizeTiers.forEach((t, i) => { const d = Math.abs((dimArea(t) || 0) - wa); if (d < best) { best = d; idx = i; } });
        }
      }
      const ratio = this.sizeTiers.length > 1 ? idx / (this.sizeTiers.length - 1) : 0;
      const ownIdx = Math.round(ratio * (own.length - 1));
      return own[Math.max(0, Math.min(own.length - 1, ownIdx))];
    }
    sizeAt(i){ return this.state.sizeBy["paid:"+i] || this.state.sizeValue }
    frameAt(i){ return this.state.frameBy["paid:"+i] || this.state.frameValue }
    findVariant(product, sizeV, frameV) {
      if (!product) return null;
      const rs = this.sizeFor(product, sizeV);
      return product.variants.find(v =>
        v.options.some(o => normStr(o) === normStr(rs)) &&
        v.options.some(o => normStr(o) === normStr(frameV))
      ) || null;
    }
    priceOf(product, sizeV, frameV) {
      const v = this.findVariant(product, sizeV, frameV);
      return v ? v.price : null;
    }
    compareOf(product, sizeV, frameV) {
      const v = this.findVariant(product, sizeV, frameV);
      if (!v) return null;
      return (v.compare_at && v.compare_at > v.price) ? v.compare_at : v.price;
    }
    refProduct() { return this.state.paid[0] || this.cfg.currentProduct || null; }
    slotProduct(key) {
      const parts = key.split(':');
      return this.state.paid[+parts[1]];
    }
    customSlots() {
      const s = this.state, out = [];
      s.paid.forEach((p, i) => { if (isCustom(p)) out.push({ key: 'paid:' + i, product: p, fields: customFieldsFor(p) }); });
      return out;
    }
    customOk() {
      const s = this.state;
      return this.customSlots().every(cs => cs.fields.every(f => ((s.custom[cs.key] || {})[f] || '').trim().length > 0));
    }
    setPack(pack) {
      const s = this.state;
      if (pack.paid === 1) { if (s.sizeBy['paid:0']) s.sizeValue = s.sizeBy['paid:0']; s.sizeBy = {}; if (s.frameBy['paid:0']) s.frameValue = s.frameBy['paid:0']; s.frameBy = {}; }
      s.pack = pack;
      s.paid = s.paid.slice(0, pack.paid); while (s.paid.length < pack.paid) s.paid.push(null);
      if (!s.paid[0] && this.cfg.currentProduct) s.paid[0] = this.cfg.currentProduct;
      this.render();
    }
    paidCount() { return this.state.paid.length; }
    totals() {
      const s = this.state; let list = 0, pay = 0, ok = true;
      s.paid.forEach((p, i) => {
        if (!p) { ok = false; return; }
        const pr = this.priceOf(p, this.sizeAt(i), this.frameAt(i));
        const cmp = this.compareOf(p, this.sizeAt(i), this.frameAt(i));
        if (pr == null) { ok = false; return; }
        list += cmp; pay += Math.round(pr * (1 - s.pack.off));
      });
      return { list, pay, saving: list - pay, ok };
    }
    estPayTotal() {
      const s = this.state, ref = this.refProduct();
      const t = this.totals();
      if (t.ok) return t.pay;
      if (!ref) return 0;
      const unitP = this.priceOf(ref, s.sizeValue, s.frameValue);
      if (unitP == null) return 0;
      return Math.round(unitP * (1 - s.pack.off)) * this.paidCount();
    }
    freeShipNow() {
      const t = this.totals();
      if (t.ok) return t.pay >= FREE_SHIP_MIN_CENTS;
      return this.estPayTotal() >= FREE_SHIP_MIN_CENTS;
    }
    itemDescriptors() {
      const s = this.state, out = [];
      s.paid.forEach((p, i) => {
        const v = this.findVariant(p, this.sizeAt(i), this.frameAt(i));
        if (!v) return;
        const key = 'paid:' + i;
        const props = { _pack: '', _pack_size: s.pack.label + (s.pack.expandable ? ' (' + s.paid.length + ')' : '') };
        const cv = s.custom[key];
        if (isCustom(p) && cv) Object.keys(cv).forEach(k => { if ((cv[k] || '').trim()) props[k] = cv[k].trim(); });
        out.push({ id: v.id, props: props, fileKey: key });
      });
      return out;
    }
    async addToCart() {
      const s = this.state; if (s.busy) return; s.busy = true; this.render();
      const packId = 'pack_' + Date.now();
      const descriptors = this.itemDescriptors();
      descriptors.forEach(d => { d.props._pack = packId; });
      const anyFile = descriptors.some(d => s.customFile[d.fileKey]);
      try {
        if (!anyFile) {
          const items = descriptors.map(d => ({ id: d.id, quantity: 1, properties: d.props }));
          const r = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
          if (!r.ok) throw new Error(await r.text());
        } else {
          for (let i = 0; i < descriptors.length; i++) {
            const d = descriptors[i];
            const fd = new FormData();
            fd.append('id', d.id);
            fd.append('quantity', '1');
            Object.keys(d.props).forEach(k => fd.append('properties[' + k + ']', d.props[k]));
            const f = s.customFile[d.fileKey];
            if (f) fd.append('properties[Custom Image]', f, f.name);
            const r = await fetch('/cart/add.js', { method: 'POST', body: fd });
            if (!r.ok) throw new Error(await r.text());
          }
        }
        s.busy = false; this.render();
        openCartDrawer('/cart');
      } catch (e) {
        console.error('[bundle-builder] add-to-cart', e);
        s.busy = false; this.render();
        alert('Could not add pack to cart. Please try again.');
      }
    }
    atcHTML() {
      const s = this.state, t = this.totals(), cok = this.customOk();
      const dis = !t.ok || !cok || s.busy;
      let label;
      if (s.busy) label = 'Adding…';
      else if (!t.ok) label = 'Fill all slots to continue';
      else if (!cok) label = 'Enter personalization to continue';
      else label = `Add to Cart — ${t.saving > 0 ? `<s>${this.fmt(t.list)}</s> ` : ''}${this.fmt(t.pay)}`;
      return `<button type="button" class="bb-atc-btn" data-bb="atc" ${dis ? 'disabled' : ''}>${label}</button>
      <div style="display:flex;align-items:center;justify-content:center;flex-wrap:wrap;text-align:center;gap:6px 10px;margin-top:10px;font-size:11.5px;font-weight:800;letter-spacing:.02em;color:#111"><span style="white-space:nowrap">✓ FAST WORLDWIDE SHIPPING</span><span style="color:#c9c6c0">|</span><span style="white-space:nowrap">🇺🇸 MADE IN USA</span></div>`;
    }
    updateAtc() {
      const wrap = this.querySelector('.bb-atc');
      if (!wrap) return;
      wrap.innerHTML = this.atcHTML();
      const atc = wrap.querySelector('[data-bb="atc"]');
      if (atc) atc.onclick = () => this.addToCart();
    }
    customFieldsHTML(key, product) {
      const fields = customFieldsFor(product);
      if (!fields) return '';
      const vals = this.state.custom[key] || {};
      const fieldsHTML = `<div class="bb-cf">${fields.map(f => `
        <div><span class="bb-optlab">${f}</span>
        <input type="text" class="bb-cfin" data-cf="${key}" data-cf-field="${f.replace(/"/g, '&quot;')}" placeholder="${f}" maxlength="60" value="${(vals[f] || '').replace(/"/g, '&quot;')}"></div>`).join('')}
      </div>`;
      let imgHTML = '';
      if (customImgFor(product)) {
        const file = this.state.customFile[key];
        imgHTML = `<div style="margin-top:10px">
          <span class="bb-optlab">Add Image <span style="font-weight:400;color:#8a8781">(optional)</span></span>
          ${file
            ? `<div style="display:flex;align-items:center;gap:8px;padding:10px 12px;border:1.5px solid #e3e1dd;border-radius:8px;background:#fff;font-size:12.5px"><span style="flex:1;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${file.name.replace(/</g, '&lt;')}</span><button type="button" data-cfimg-clear="${key}" style="all:unset;cursor:pointer;width:22px;height:22px;border-radius:50%;background:#111;color:#fff;font-size:12px;display:flex;align-items:center;justify-content:center;flex:0 0 auto">×</button></div>`
            : `<label style="display:flex;align-items:center;justify-content:center;gap:6px;padding:10px 12px;border:1.5px dashed #c9c6c0;border-radius:8px;background:#fff;font-size:12.5px;font-weight:700;color:#111;cursor:pointer">+ Upload Image<input type="file" accept="image/*" data-cfimg="${key}" style="display:none"></label>`}
        </div>`;
      }
      return fieldsHTML + imgHTML;
    }
    render() {
      if (this._portal) { this._portal.remove(); this._portal = null; }
      const s = this.state, c = this.cfg, multi = s.pack.paid > 1;
      const ref = this.refProduct();
      const unitP = ref ? this.priceOf(ref, s.sizeValue, s.frameValue) : null;
      const unitC = ref ? this.compareOf(ref, s.sizeValue, s.frameValue) : null;
      let priceHTML = '';
      if (unitP != null) {
        const nPaid = this.paidCount();
        const t = this.totals();
        const listTotal = t.ok ? t.list : unitC * nPaid;
        const payTotal = t.ok ? t.pay : Math.round(unitP * (1 - s.pack.off)) * nPaid;
        const save = listTotal - payTotal;
        const shipPill = this.freeShipNow() ? `<span style="background:#0a7d33;color:#fff;font-size:11px;font-weight:800;padding:3px 8px;border-radius:4px;letter-spacing:.03em;white-space:nowrap">FREE US SHIPPING</span>` : '';
        if (save > 0) {
          priceHTML = `<div class="bb-price" style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;font-size:18px;font-weight:800;color:#111;margin:2px 0 6px;line-height:1.2"><span><span style="font-weight:600;font-size:14px;margin-right:4px">From</span><s style="color:#8a8781;font-weight:400;font-size:14px;margin-right:8px">${this.fmt(listTotal)}</s>${this.fmt(payTotal)}</span><span style="background:#d92c20;color:#fff;font-size:11px;font-weight:800;padding:3px 8px;border-radius:4px;letter-spacing:.03em;white-space:nowrap">SAVE ${this.fmt(save)}</span>${shipPill}</div>`;
        } else {
          priceHTML = `<div class="bb-price" style="display:flex;align-items:center;gap:10px;flex-wrap:wrap;font-size:18px;font-weight:800;color:#111;margin:2px 0 6px;line-height:1.2"><span>${this.fmt(unitP)}</span>${shipPill}</div>`;
        }
      }
      const curPrice = unitP != null ? (s.pack.off ? this.fmt(Math.round(unitP * (1 - s.pack.off))) : this.fmt(unitP)) : '';
      const singleCustom = !multi && isCustom(s.paid[0]) ? this.stepH(2, 'Personalize Your Print') + this.customFieldsHTML('paid:0', s.paid[0]) : '';
      const stepBase = multi ? 3 : (singleCustom ? 3 : 2);
      const frameStep = multi ? stepBase : stepBase + 1;
      this.querySelector('[data-bb-root]').innerHTML = `
        ${priceHTML}
        <div class="bb-card">
        ${this.stepH(1, 'Build Your Bundle')}
        <div class="bb-packs">${c.packs.map(p => `
          <button type="button" class="bb-pack ${p.id === s.pack.id ? 'active' : ''}" data-pack="${p.id}">
            ${p.off ? `<span class="bb-off">EXTRA ${Math.round(p.off * 100)}% OFF</span>` : ''}
            <span class="bb-pack-name">${p.label}</span>
            ${p.best ? `<span class="bb-under"><span class="bb-bestbar">BEST VALUE</span></span>` : ''}
          </button>`).join('')}
        </div>
        ${multi ? this.stepH(2, 'Choose Your Prints', this.filledCount() + '/' + s.paid.length + ' added') + `<div class="bb-slots">${this.slotsHTML()}</div>` : singleCustom}
        ${multi ? '' : this.stepH(stepBase, 'Choose Your Size') + `
        <div class="bb-sizedd ${s.sizeOpenKey === 'step2' ? 'open' : ''}" data-bb="sizedd">
          <button type="button" class="bb-sizedd-btn" data-bb="size-toggle">
            <span>${dispSizeCm(s.sizeValue)}</span>
            <span class="bb-sizedd-price">${curPrice}</span>
            <span class="bb-caret">▾</span>
          </button>
          <div class="bb-sizedd-list">${c.sizes.map(z => {
            const pr = ref ? this.priceOf(ref, z, s.frameValue) : null;
            const cm = ref ? this.compareOf(ref, z, s.frameValue) : null;
            if (pr == null) return '';
            const eff = s.pack.off ? Math.round(pr * (1 - s.pack.off)) : pr;
            const rowPrice = (cm && cm > eff) ? `<s>${this.fmt(cm)}</s> ${this.fmt(eff)}` : this.fmt(eff);
            return `<button type="button" class="bb-sizedd-row ${z === s.sizeValue ? 'sel' : ''}" data-size="${z.replace(/"/g, '&quot;')}">
              <span>${dispSizeCm(z)}${popBadge(z)}</span>
              <span class="bb-sizedd-rowprice">${rowPrice}</span>
            </button>`;
          }).join('')}</div>
        </div>`}
        ${multi ? '' : this.stepH(frameStep, 'Choose Your Frame') + `<div class="bb-frames">${c.frames.map(f => {
          const img = this.frameImg(f);
          const chipInner = img ? `<img src="${img}" alt="${f}" loading="lazy">` : '<span></span>';
          return `
          <button type="button" class="bb-frame ${f === s.frameValue ? 'active' : ''}" data-frame="${f}">
            ${/black/i.test(f) ? '<span class="bb-pop">POPULAR</span>' : ''}
            <span class="bb-chip" data-f="${f.toLowerCase().replace(/[^a-z]/g, '')}">${chipInner}</span>
            <span class="bb-frame-label">${f}</span>
          </button>`;
        }).join('')}
        </div>`}
        </div>
        <div class="bb-atc">${this.atcHTML()}</div>
        ${this.pickerHTML()}`;
      this.bind();
      if (s.pickTarget) {
        const row = (this._portal || this).querySelector('.bb-collrow');
        const act = (this._portal || this).querySelector('.bb-coll.active');
        centerH(row, act);
      }
    }
    stepH(n, title, hint) {
      return `<div class="bb-step-h"><span class="bb-n">${n}</span><h3>${title}</h3>${hint ? `<span class="bb-hint">${hint}</span>` : ''}</div>`;
    }
    filledCount() { return this.state.paid.filter(Boolean).length; }
    slotsHTML() {
      const s = this.state;
      const paidHTML = s.paid.map((p, i) => {
        if (!p) return `<div class="bb-slot bb-empty" data-pick="paid:${i}"><div class="bb-art">+</div><div class="bb-body"><div class="bb-t">Empty Slot</div><div class="bb-s">Tap to add print</div></div>${s.pack.expandable && s.paid.length > s.pack.paid ? `<button type="button" class="bb-remove" data-remove="paid:${i}">×</button>` : ''}</div>`;
        const rs = this.sizeFor(p, this.sizeAt(i));
        const fr = this.frameAt(i);
        const pr = this.priceOf(p, this.sizeAt(i), fr);
        const cm = this.compareOf(p, this.sizeAt(i), fr);
        const pay = pr != null ? Math.round(pr * (1 - s.pack.off)) : null;
        const slotKey = 'paid:' + i;
        const frameKey = 'frame:' + slotKey;
        const optsCtl = s.pack.paid > 1
          ? `<div class="bb-slotopts">
              <div class="bb-slotopt">
                <span class="bb-slotopt-l">Size</span>
                <div class="bb-sizedd bb-slotsize ${s.sizeOpenKey === slotKey ? 'open' : ''}" data-slot-size="${slotKey}">
                  <button type="button" class="bb-sizedd-btn" data-slot-size-toggle="${slotKey}">
                    <span>${dispSize(rs)}</span>
                    <span class="bb-caret">▾</span>
                  </button>
                  <div class="bb-sizedd-list">${this.sizesOf(p).map(z => {
                    const zpr = this.priceOf(p, z, fr);
                    const zcm = this.compareOf(p, z, fr);
                    if (zpr == null) return '';
                    const zeff = s.pack.off ? Math.round(zpr * (1 - s.pack.off)) : zpr;
                    const zRowPrice = (zcm && zcm > zeff) ? `<s>${this.fmt(zcm)}</s> ${this.fmt(zeff)}` : this.fmt(zeff);
                    return `<button type="button" class="bb-sizedd-row ${normStr(z) === normStr(rs) ? 'sel' : ''}" data-slot-size-row="${slotKey}" data-slot-size-val="${z.replace(/"/g, '&quot;')}">
                      <span>${dispSizeCm(z)}</span>
                      <span class="bb-sizedd-rowprice">${zRowPrice}</span>
                    </button>`;
                  }).join('')}</div>
                </div>
              </div>
              <div class="bb-slotopt">
                <span class="bb-slotopt-l">Framing</span>
                <div class="bb-sizedd bb-slotframe ${s.sizeOpenKey === frameKey ? 'open' : ''}" data-slot-frame="${slotKey}">
                  <button type="button" class="bb-sizedd-btn" data-slot-frame-toggle="${slotKey}">
                    <span>${fr}</span>
                    <span class="bb-caret">▾</span>
                  </button>
                  <div class="bb-sizedd-list">${this.cfg.frames.map(f => {
                    return `<button type="button" class="bb-sizedd-row ${normStr(f) === normStr(fr) ? 'sel' : ''}" data-slot-frame-row="${slotKey}" data-slot-frame-val="${f.replace(/"/g, '&quot;')}">
                      <span>${f}</span>
                    </button>`;
                  }).join('')}</div>
                </div>
              </div>
            </div>`
          : `<div class="bb-s">${dispSizeCm(rs)} · ${fr}</div>`;
        const custom = isCustom(p) ? this.customFieldsHTML('paid:' + i, p) : '';
        return `<div class="bb-slot ${custom ? 'bb-slot-col' : ''}">
          <button type="button" class="bb-remove" data-remove="paid:${i}">×</button>
          <div class="bb-slot-row">
            <div class="bb-art" data-pick="paid:${i}">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}</div>
            <div class="bb-body">
              <div class="bb-thead">
                <div class="bb-t">${p.title}</div>
                <div class="bb-p">${pay != null ? ((cm && cm > pay) ? `<s>${this.fmt(cm)}</s> ` : '') + this.fmt(pay) : '—'}</div>
              </div>
              ${optsCtl}
            </div>
          </div>
          ${custom}
        </div>`;
      }).join('');
      const addMore = (s.pack.expandable && s.paid.length < 10)
        ? `<div class="bb-slot bb-empty bb-addmore" data-bb="add-slot">+ Add Another Print — 20% OFF</div>`
        : '';
      return paidHTML + addMore;
    }
    pickerHTML() {
      const c = this.cfg, s = this.state;
      const colls = this.sliderColls || [];
      let list = c.catalog.filter(p => !s.filter || collsOf(p).includes(s.filter));
      return `<div class="bb-picker ${s.pickTarget ? 'open' : ''}" data-bb="picker">
        <div class="bb-sheet">
          <div class="bb-picker-head" style="display:flex;align-items:center;justify-content:space-between">
            <h4>Choose Your Print</h4>
            <button type="button" class="bb-picker-done" data-bb="picker-close" style="margin-left:auto;background:#111;color:#fff;border:0;border-radius:999px;padding:9px 20px;font-size:13px;font-weight:800;line-height:1;cursor:pointer;display:inline-flex;align-items:center;justify-content:center">Done</button>
          </div>
          <div class="bb-collrow">${colls.map(x => `
            <button type="button" class="bb-coll ${x.title === s.filter ? 'active' : ''}" data-coll="${x.title.replace(/"/g, '&quot;')}">
              <span class="bb-coll-img">${x.img ? `<img src="${x.img}" alt="" loading="lazy">` : ''}</span>
              <span class="bb-coll-name">${x.label}</span>
            </button>`).join('')}
          </div>
          <div class="bb-picker-grid">${list.length ? list.map(p => `
            <div class="bb-pick-card">
              <div class="bb-pick-art">${p.image ? `<img src="${p.image}" alt="" loading="lazy">` : ''}</div>
              <div class="bb-pick-t">${p.title}</div>
              <button type="button" data-add="${p.id}">+ Add</button>
            </div>`).join('') : '<div class="bb-picker-empty">No prints found in this collection</div>'}
          </div>
        </div>
      </div>`;
    }
    bind() {
      const s = this.state, c = this.cfg;
      this.querySelectorAll('[data-pack]').forEach(b => b.onclick = () => this.setPack(c.packs.find(p => p.id === b.dataset.pack)));
      const st = this.querySelector('[data-bb="size-toggle"]'); if (st) st.onclick = () => { s.sizeOpenKey = s.sizeOpenKey === 'step2' ? null : 'step2'; this.render(); };
      this.querySelectorAll('[data-size]').forEach(b => b.onclick = () => { s.sizeValue = b.dataset.size; s.sizeBy = {}; s.sizeOpenKey = null; this.render(); });
      this.querySelectorAll('[data-slot-size-toggle]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        const k = b.dataset.slotSizeToggle;
        s.sizeOpenKey = s.sizeOpenKey === k ? null : k;
        this.render();
      });
      this.querySelectorAll('[data-slot-size-row]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        s.sizeBy[b.dataset.slotSizeRow] = b.dataset.slotSizeVal;
        s.sizeOpenKey = null;
        this.render();
      });
      this.querySelectorAll('[data-slot-frame-toggle]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        const k = 'frame:' + b.dataset.slotFrameToggle;
        s.sizeOpenKey = s.sizeOpenKey === k ? null : k;
        this.render();
      });
      this.querySelectorAll('[data-slot-frame-row]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        s.frameBy[b.dataset.slotFrameRow] = b.dataset.slotFrameVal;
        s.sizeOpenKey = null;
        this.render();
      });
      this.querySelectorAll('[data-frame]').forEach(b => b.onclick = () => { s.frameValue = b.dataset.frame; s.frameBy = {}; this.render(); });
      this.querySelectorAll('[data-pick]').forEach(el => el.onclick = () => { s.pickTarget = el.dataset.pick; this.render(); });
      const addSlot = this.querySelector('[data-bb="add-slot"]');
      if (addSlot) addSlot.onclick = () => { if (s.paid.length < 10) { s.paid.push(null); this.render(); } };
      this.querySelectorAll('[data-remove]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        const idx = +b.dataset.remove.split(':')[1];
        if (s.pack.expandable && s.paid.length > s.pack.paid) {
          s.paid.splice(idx, 1);
          s.custom = shiftKeys(s.custom, 'paid', idx);
          s.customFile = shiftKeys(s.customFile, 'paid', idx);
          s.sizeBy = shiftKeys(s.sizeBy, 'paid', idx);
          s.frameBy = shiftKeys(s.frameBy, 'paid', idx);
        } else {
          s.paid[idx] = null;
          delete s.custom['paid:' + idx];
          delete s.customFile['paid:' + idx];
          delete s.sizeBy['paid:' + idx];
          delete s.frameBy['paid:' + idx];
        }
        this.render();
      });
      this.querySelectorAll('[data-cf]').forEach(inp => inp.oninput = e => {
        const key = e.target.dataset.cf, field = e.target.dataset.cfField;
        if (!s.custom[key]) s.custom[key] = {};
        s.custom[key][field] = e.target.value;
        this.updateAtc();
      });
      this.querySelectorAll('[data-cfimg]').forEach(inp => inp.onchange = e => {
        const f = e.target.files && e.target.files[0];
        if (f) {
          if (f.size > 10 * 1024 * 1024) { alert('Image must be under 10MB'); e.target.value = ''; return; }
          s.customFile[e.target.dataset.cfimg] = f;
        }
        this.render();
      });
      this.querySelectorAll('[data-cfimg-clear]').forEach(b => b.onclick = e => {
        e.stopPropagation();
        delete s.customFile[b.dataset.cfimgClear];
        this.render();
      });
      const picker = this.querySelector('[data-bb="picker"]');
      if (picker) {
        picker.querySelectorAll('[data-coll]').forEach(b => b.onclick = () => { s.filter = b.dataset.coll; this.render(); });
        picker.querySelectorAll('[data-add]').forEach(b => b.onclick = () => {
          const p = c.catalog.find(x => String(x.id) === b.dataset.add);
          const parts = s.pickTarget.split(':');
          s.paid[+parts[1]] = p;
          delete s.custom[s.pickTarget];
          delete s.customFile[s.pickTarget];
          if (isCustom(p)) s.custom[s.pickTarget] = {};
          s.pickTarget = null; this.render();
        });
        const close = picker.querySelector('[data-bb="picker-close"]'); if (close) close.onclick = () => { s.pickTarget = null; this.render(); };
        picker.onclick = e => { if (e.target === picker) { s.pickTarget = null; this.render(); } };
        document.body.appendChild(picker);
        this._portal = picker;
      }
      const atc = this.querySelector('[data-bb="atc"]'); if (atc) atc.onclick = () => this.addToCart();
    }
  }
  document.addEventListener('click', function (e) {
    document.querySelectorAll('ethetic-bundle-builder').forEach(el => {
      if (el.state && el.state.sizeOpenKey && !e.target.closest('[data-bb="sizedd"]') && !e.target.closest('[data-slot-size]') && !e.target.closest('[data-slot-frame]')) { el.state.sizeOpenKey = null; el.render(); }
    });
  });
  if (!customElements.get('ethetic-bundle-builder')) customElements.define('ethetic-bundle-builder', EtheticBundleBuilder);
})();
